module.exports = __webpack_public_path__ + "static/media/yanxia.54ec7f45.jpg";